import { useTranslation } from "@equiem/web-ng-lib";
import { Button, Site, Theme } from "@equiem/web-ng-lib";
import { useContext } from "react";

export const RegisterNow: React.FC = () => {
  const { t } = useTranslation();

  const theme = useContext(Theme);
  const actionsWidth = 64;
  const padding = 30;
  const site = useContext(Site);

  return (
    <>
      <div className="cta p-5 rounded mb-5">
        <h1 className="font-weight-bold">
          {t("main.interestedInSeeingMore")}
          <br />
          <sub className="text-muted">
            {t("main.partOfCommunityCommentOrSeeMoreRegisterNow", { siteName: site.name })}
          </sub>
        </h1>
        <Button
          variant="solid"
          href="/api/login?screen_hint=signup&utm_medium=sc"
          size="lg"
          className="mt-4"
          prefetch={false}
        >
          {t("main.registerNow")}
        </Button>
      </div>
      <style jsx>{`
        @media screen and (min-width: ${theme.breakpoints.md}px) {
          .cta {
            max-width: calc(100% - ${actionsWidth * 2}px);
          }
        }
        @media screen and (min-width: ${theme.breakpoints.lg}px) {
          .cta {
            max-width: ${theme.breakpoints.md - actionsWidth + padding}px;
            margin: 0 auto;
          }
        }
        .cta {
          background-color: #f9f9f9;
        }

        .cta > h1 {
          font-size: 2rem;
        }

        .cta > h1 sub {
          display: inline-block;
          font-size: 1.25rem;
          line-height: 1.5;
        }
      `}</style>
    </>
  );
};
